import moment from 'moment';
import schema from '../../AposentadosDemitidos/PreencherDados/schema';

import { cloneObject } from '../../../../utils';

const DATE_API_FORMAT = 'MM/DD/YYYY HH:mm:ss';

function aposentadosDemitidos(beneficiario) {
    const { form } = beneficiario;

    const dadosBeneficiario = cloneObject(schema);

    form.dataInicioSituacaoInatividade =
        form.dataInicioSituacaoInatividade && moment(form.dataInicioSituacaoInatividade, DATE_API_FORMAT).toISOString();
    form.dataInicioPeriodoInatividade =
        form.dataInicioPeriodoInatividade && moment(form.dataInicioPeriodoInatividade, DATE_API_FORMAT).toISOString();
    form.dataFinalPeriodoInatividade =
        form.dataFinalPeriodoInatividade && moment(form.dataFinalPeriodoInatividade, DATE_API_FORMAT).toISOString();
    form.dataInicioContrbuicao =
        form.dataInicioContrbuicao && moment(form.dataInicioContrbuicao, DATE_API_FORMAT).toISOString();

    dadosBeneficiario.situation.value = form.situacaoInatividade;
    dadosBeneficiario.demissionDate.value = form.dataInicioSituacaoInatividade;
    dadosBeneficiario.stayCompany.value = [form.dataInicioPeriodoInatividade, form.dataFinalPeriodoInatividade];
    dadosBeneficiario.dueDate.value = form.diaPagamento;
    dadosBeneficiario.observation.value = form.textoObservacao;

    if (form.tipoPeriodoContribuicao === '1') {
        dadosBeneficiario.radioContribution.value = 'I';
        dadosBeneficiario.contributionDate.value = form.dataInicioContrbuicao;
    }

    if (form.tipoPeriodoContribuicao === '2') {
        dadosBeneficiario.radioContribution.value = 'T';
        dadosBeneficiario.contributionYears.value = form.quantidadeAnosContribuicao;
        dadosBeneficiario.contributionMonths.value = form.quantidadeMesesContribuicao;
        dadosBeneficiario.contributionDays.value = form.quantidadeDiasContribuicao;
    }

    return dadosBeneficiario;
}

export { aposentadosDemitidos };
